export enum FINANCE_ADJUST_TYPE {
    WRONG_RECHARGE = 1,
    BUSINESS_CHANGE = 2,
    ACCOUNT_TRANSFER = 3,
}
